import axios from 'axios';


export default (query, callback, errorCallback, apiUrl, headers) => {
  axios({
    method: 'POST',
    url: apiUrl + '/rt/console/messaging/get-threads',
    data: {
      ...headers,
      userId: query.id,
      nct: query.nct,
    }
  })
  .then(res => callback(res))
  .catch(err => errorCallback ? errorCallback(err) : null)
}
